export default "__VITE_ASSET__BS2p1bS7__"